var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 36C28.665 36 36.5 28.165 36.5 18.5C36.5 8.83502 28.665 1 19 1C9.33502 1 1.5 8.83502 1.5 18.5C1.5 28.165 9.33502 36 19 36Z",
    stroke: "#FF4A4A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 15.7916C18.2815 15.7916 17.5927 16.077 17.0848 16.5849C16.5768 17.0928 16.2915 17.7817 16.2915 18.5C16.2915 19.2183 16.5768 19.9071 17.0848 20.415C17.5927 20.923 18.2815 21.2083 18.9998 21.2083C19.7181 21.2083 20.407 20.923 20.9149 20.415C21.4228 19.9071 21.7082 19.2183 21.7082 18.5C21.7082 17.7817 21.4228 17.0928 20.9149 16.5849C20.407 16.077 19.7181 15.7916 18.9998 15.7916Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6415 11.0683C17.5382 10.7474 20.4615 10.7474 23.3582 11.0683C24.9407 11.245 26.2165 12.4908 26.4024 14.0791C26.7456 17.0164 26.7456 19.9836 26.4024 22.9208C26.2165 24.5091 24.9407 25.755 23.359 25.9325C20.4621 26.2534 17.5385 26.2534 14.6415 25.9325C13.059 25.755 11.7832 24.5091 11.5974 22.9216C11.254 19.9841 11.254 17.0166 11.5974 14.0791C11.7832 12.4908 13.059 11.245 14.6415 11.0683ZM23.1665 13.5C22.9455 13.5 22.7335 13.5878 22.5773 13.7441C22.421 13.9003 22.3332 14.1123 22.3332 14.3333C22.3332 14.5543 22.421 14.7663 22.5773 14.9226C22.7335 15.0788 22.9455 15.1666 23.1665 15.1666C23.3875 15.1666 23.5995 15.0788 23.7558 14.9226C23.9121 14.7663 23.9999 14.5543 23.9999 14.3333C23.9999 14.1123 23.9121 13.9003 23.7558 13.7441C23.5995 13.5878 23.3875 13.5 23.1665 13.5ZM15.0415 18.5C15.0415 17.4502 15.4586 16.4433 16.2009 15.701C16.9432 14.9587 17.95 14.5416 18.9999 14.5416C20.0497 14.5416 21.0565 14.9587 21.7988 15.701C22.5412 16.4433 22.9582 17.4502 22.9582 18.5C22.9582 19.5498 22.5412 20.5566 21.7988 21.2989C21.0565 22.0413 20.0497 22.4583 18.9999 22.4583C17.95 22.4583 16.9432 22.0413 16.2009 21.2989C15.4586 20.5566 15.0415 19.5498 15.0415 18.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.33867027690e30fd922c55ea913e8cf8.svg";
export { ForwardRef as ReactComponent };